<template>
  <donut-modal
    v-model="isOpen"
    title="We're gathering your insights!"
    :cancelable="false"
    :button="'Ok'"
    @save="onOk"
  >
    <div class="f-v f-gap-8">
      <p class="t display m-0">
        Donut is currently analyzing the communication pulse of your channels.
      </p>
      <p class="t display m-0">
        This process takes a few hours to complete.
      </p>
      <p class="t display m-0">
        No need to wait here! We'll ping you on Slack as soon as the data is live.
      </p>
    </div>
  </donut-modal>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['update:modelValue']);

const isOpen = computed({
  get: () => props.modelValue,
  set: (val) => emit('update:modelValue', val),
});

const onOk = () => {
  isOpen.value = false;
  window.location.reload();
};
</script>
